export interface ChevronDownIconProps {
  height?: number;
  width?: number;
  className?: string;
  fillColor?: string;
}

const ChevronDownIcon = ({
  height = 16,
  width = 16,
  className,
  fillColor,
}: ChevronDownIconProps) => {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="2 1 16 16"
        fill="none"
      >
        <path
          d="M16 7L10.2827 12.7168C10.2077 12.7918 10.106 12.834 10 12.834C9.89396 12.834 9.79226 12.7918 9.71733 12.7168L4 7"
          stroke="#727272"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={fillColor || "#373737"}
        />
      </svg>
    </div>
  );
};

export default ChevronDownIcon;
